var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_119_4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 24C49 37.2548 38.031 48 24.5 48C10.969 48 0 37.2548 0 24C0 10.7452 10.969 0 24.5 0C12.5 6.5 17.5 42 49 24Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 24C49 37.2548 38.031 48 24.5 48C10.969 48 0 37.2548 0 24C0 10.7452 10.969 0 24.5 0C12.5 6.5 17.5 42 49 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 24H54V15.3841L46.5193 19.6588L49 24ZM24.5 0L26.8814 4.39646L24.5 -5V0ZM44 24C44 34.3967 35.3672 43 24.5 43V53C40.6947 53 54 40.1129 54 24H44ZM24.5 43C13.6328 43 5 34.3967 5 24H-5C-5 40.1129 8.30529 53 24.5 53V43ZM5 24C5 13.6033 13.6328 5 24.5 5V-5C8.30529 -5 -5 7.88705 -5 24H5ZM22.1186 -4.39646C17.3111 -1.79242 14.8019 3.30239 13.918 8.12133C13.016 13.0389 13.5898 18.6322 15.9579 23.4085C18.3857 28.3053 22.781 32.4339 29.2586 33.6693C35.5637 34.8718 43.0196 33.1761 51.4807 28.3412L46.5193 19.6588C39.2304 23.8239 34.2488 24.4407 31.132 23.8463C28.1877 23.2848 26.1768 21.5072 24.9171 18.9665C23.5977 16.3053 23.2028 12.9299 23.7539 9.92555C24.3231 6.82261 25.6889 5.04242 26.8814 4.39646L22.1186 -4.39646Z",
    fill: "#14395C",
    mask: "url(#path-1-inside-1_119_4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.35a099e5a9d7c69da4c69aefe1da8e5d.svg";
export { ForwardRef as ReactComponent };